// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Fm2ql","label":"Section_label__M7uD1","contentWrap":"Section_contentWrap__3bv1v","footer":"Section_footer__2hKEi","footerInner":"Section_footerInner__3XcuH"};